import { axios, transformAxiosError } from "../utils/axios.create";
import {
  RolePayload,
  RoleType,
  SearchRolePayload,
  SearchRoleResponse,
  UserRoleType,
} from "../domain/role.interface";

const findAll = async ({ status }: { status: string }): Promise<RoleType[]> => {
  return axios
    .get(`/roles?status=${status}`)
    .then((res) => {
      return res.data.body as RoleType[];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findById = async (id: string): Promise<RoleType> => {
  return axios
    .get(`/roles/${id}`)
    .then((res) => {
      return res.data.body as RoleType;
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findByUserId = async (userId: string): Promise<UserRoleType[]> => {
  return axios
    .get(`/users/${userId}/roles`)
    .then((res) => {
      return res.data.body as UserRoleType[];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const search = async ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
  status,
}: SearchRolePayload): Promise<SearchRoleResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
    search,
    status: (status || []).join(","),
  });

  return axios
    .get(`/roles/search?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        roles: body.roles,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (data: RolePayload) => {
  return axios
    .post("/roles", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({ id, data }: { id: string; data: RolePayload }) => {
  return axios
    .put(`/roles/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/roles/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const RolesService = {
  findAll,
  findById,
  findByUserId,
  search,
  create,
  update,
  softDelete,
};
